// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1Zy_5","question":"Question_question__3BJJx","description":"Question_description__2VLN2"};